// test1544
(1544 && 0);
